import React from 'react';
import BankOutlined from '@ant-design/icons/BankOutlined';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { currencyUSDFormatter } from '../../../../domain/common/currencyFormatters';
import { ISiteLocation } from '../../../../domain/site/interface';
import './SelectedSiteInfo.css';

interface ISelectedSiteInfoProps {
    sites: ISiteLocation[];
    onClose: () => void;
}

export const SelectedSiteInfo: React.FC<ISelectedSiteInfoProps> = ({ sites, onClose }) => {
    const [first] = sites;

    return (
        <InfoWindow
            className="selected-site-info"
            onCloseClick={onClose}
            pixelOffset={[0, -15]}
            position={{
                lat: +first.site_lat,
                lng: +first.site_long,
            }}
        >
            <div className="marker-info-window" style={sites.length > 1 ? { maxHeight: 300, overflowY: 'auto' } : undefined}>
                {sites.map((site, index) => (
                    <div key={site.site_id} style={index > 0 ? { borderTop: '1px solid #e8e8e8', paddingTop: 8, marginTop: 8 } : undefined}>
                        <div className="info-window-title">
                            <BankOutlined /> {site.company_name}
                        </div>
                        <div className="info-window-subtitle">{site.site_name}</div>
                        <div>{site.site_address}</div>

                        {!!(site?.lmp_price_rt && site?.lmp_price_da) && (
                            <>
                                <br />
                                <div>
                                    <span className="info-window-subtitle">Real Time:&nbsp;</span>
                                    {currencyUSDFormatter.format(site.lmp_price_rt as number)}
                                </div>
                                <div>
                                    <span className="info-window-subtitle">Day Ahead:&nbsp;</span>
                                    {currencyUSDFormatter.format(site.lmp_price_da as number)}
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </InfoWindow>
    );
};
